import { render, staticRenderFns } from "./CrudSprint.vue?vue&type=template&id=3d891c88&scoped=true"
import script from "./CrudSprint.vue?vue&type=script&lang=js"
export * from "./CrudSprint.vue?vue&type=script&lang=js"
import style0 from "./CrudSprint.vue?vue&type=style&index=0&id=3d891c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d891c88",
  null
  
)

export default component.exports